import { context } from '../state/session.js';

/**
 * Staat het actieve huishouden op pauze (AMUMIN Beheer, 0035)? Dan blijft alles zichtbaar, maar
 * wijzigen geeft 423 household_paused. Review g4 ux r2: de pagina's verbergen dan ook hun
 * belangrijkste knoppen om iets te wijzigen ("+ Afspraak", "Ik rijd", "Locatie kiezen"), zodat
 * de app er ook echt als "alleen kijken" uitziet; de banner (PausedBanner) zegt waarom.
 */
export function householdPaused(): boolean {
  const ctx = context.value;
  const active = ctx?.households.find((h) => h.id === ctx.active_household_id);
  // Golf 8 (0050): een meekijker (relative) kijkt alleen; ook voor hem geen knoppen om te wijzigen
  // (de API weigert het toch). De pauzebanner volgt alleen `paused` zelf.
  return active?.paused === true || active?.role === 'relative';
}
